<template>
    <div>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <b-card class="sa-card sa-card-border" header="Anamnesi PsichiatricaProssima" header-tag="header" footer-tag="footer" title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <span v-if="isReadOnly">{{ jsonDataAnamnesiPsichiatricaProssima.voce }}</span>
                            <b-form-textarea v-else v-model="jsonDataAnamnesiPsichiatricaProssima.voce" :readonly="isReadOnly" max-rows="10" rows="8"> </b-form-textarea>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    props: {
        isReadOnly: {
            type: Boolean,
            default: false,
        },
        idAccettazione: {
            type: String,
        },
        jsonDataAnamnesiPsichiatricaProssima: {
            type: Object,
            default: function () {
                return {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    voce: "",
                };
            },
        },
    },
    mixins: [UtilityMixin],
    watch: {
        jsonDataAnamnesiPsichiatricaProssima: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    data() {
        return {
            pathResourceSchedaRelazioneSanitariaAnamnesiPsichiatricaProssima: "/rsaschedarelazionesanitariaanamnesipsichiatricaprossima",
        };
    },
    methods: {
        loadSchedaRelazioneSanitariaAnamnesiPsichiatricaProssima() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceSchedaRelazioneSanitariaAnamnesiPsichiatricaProssima + "/accettazione/" + me.idAccettazione, {}, me.resultResponseSchedaRelazioneSanitariaAnamnesiPsichiatricaProssimaSuccess, me.resultResponseSchedaRelazioneSanitariaAnamnesiPsichiatricaProssimaError);
        },

        resultResponseSchedaRelazioneSanitariaAnamnesiPsichiatricaProssimaSuccess(response) {
            let me = this;
            me.jsonDataAnamnesiPsichiatricaProssima = response.data.data;
        },

        resultResponseSchedaRelazioneSanitariaAnamnesiPsichiatricaProssimaError(error) {
            let me = this;
            if (error.response && error.response.status === 404) {
                me.resetForm();
            }
        },

        resetForm() {
            let me = this;
            me.jsonDataAnamnesiPsichiatricaProssima = {
                id: null,
                idAccettazione: me.idAccettazione,
                voce: null,
            };
        },

        onAnamnesiPsichiatricaProssima() {
            let me = this;
            me.jsonDataAnamnesiPsichiatricaProssima.idAccettazione = me.idAccettazione;
            if (!me.jsonDataAnamnesiPsichiatricaProssima.idAccettazione) {
                me.$bvToast.toast("Errore: ID Accettazione mancante", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
                return;
            }
            UtilityMixin.methods.saveResource(me.pathResourceSchedaRelazioneSanitariaAnamnesiPsichiatricaProssima, me.jsonDataAnamnesiPsichiatricaProssima, me.saveSchedaRelazioneSanitariaAnamnesiPsichiatricaProssimaSuccessResponse, me.saveSchedaRelazioneSanitariaAnamnesiPsichiatricaProssimaErrorResponse);
        },
        saveSchedaRelazioneSanitariaAnamnesiPsichiatricaProssimaSuccessResponse() {},
        saveSchedaRelazioneSanitariaAnamnesiPsichiatricaProssimaErrorResponse() {
            console.error("Errore nel salvataggio anamnesi psichiatricaprossima:");
        },
    },
};
</script>
